import {
  DEFAULT_WHY_BUY_PLACEHOLDER_LABEL,
  WHY_BUY_PLACEHOLDER_LABELS
} from '~/constants/vdp/whyBuyPlaceholder';

export default function getWhyBuyPlaceholderLabel(bulletType?: string) {
  return (
    (bulletType &&
      Object.hasOwn(WHY_BUY_PLACEHOLDER_LABELS, bulletType) &&
      WHY_BUY_PLACEHOLDER_LABELS[bulletType]) ||
    DEFAULT_WHY_BUY_PLACEHOLDER_LABEL
  );
}
